import { render, staticRenderFns } from "./icontextlist.vue?vue&type=template&id=3a2cd226&scoped=true"
import script from "./icontextlist.vue?vue&type=script&lang=js"
export * from "./icontextlist.vue?vue&type=script&lang=js"
import style0 from "./icontextlist.vue?vue&type=style&index=0&id=3a2cd226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2cd226",
  null
  
)

export default component.exports